/*
 * Colour swatches on product cards — swaps the card image, nothing more.
 *
 * Delegated from the document so it covers cards that arrive later: slider
 * sections, the collection grid's infinite scroll, and Section Rendering API
 * responses. There is no per-card setup and no observer.
 *
 * The card is wrapped in a full-size link, so a click on a swatch has to be
 * stopped before it navigates to the product page.
 */
(function () {
  var SWATCH = '[data-plush-swatch]';

  function cardImage(swatch) {
    var card = swatch.closest('.card-wrapper');
    return card && card.querySelector('.card__media img, .card__inner img');
  }

  document.addEventListener(
    'click',
    function (event) {
      var swatch = event.target.closest && event.target.closest(SWATCH);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();

      var img = cardImage(swatch);
      var src = swatch.getAttribute('data-swap');
      if (img && src) {
        // srcset would otherwise keep overriding src on every resize.
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
      }

      var group = swatch.closest('[data-plush-card-swatches]');
      if (group) {
        group.querySelectorAll(SWATCH).forEach(function (other) {
          other.classList.toggle('is-selected', other === swatch);
        });
      }
    },
    true
  );
})();
